import { useEffect, useState } from "react";
import { Card, CardBody } from "react-bootstrap";
import DashElv from "./DashElv";

const DashElvsCard = ({elvs}) => {

    const [filteredElvs, setFilteredElvs] = useState([]);
    const [toggleAll, setToggleAll] = useState(false);
    const showLimit = 4;

    useEffect(() => {
        if (elvs && elvs.length > 0) {
            const temp = Array.from(
            elvs.reduce((map, item) => {
                if (!item || !item.x_anlage_id || !item.x_anlage_id[0]) return map;

                const key = item.x_anlage_id[0];
                const existing = map.get(key);
                const itemId = Number(item.id);
                if (!existing || itemId > Number(existing.id)) {
                map.set(key, item);
                }
                return map;
            }, new Map()).values()
            );

            setFilteredElvs(temp);
        } else {
            setFilteredElvs([]);
        }
    }, [elvs]);

    return (
        <Card className="shadow-lg" style={{borderRadius: 15}}>
            <CardBody>
                <b>{filteredElvs && filteredElvs.length > 0? "Aktive Energielieferverträge" : "Keine aktiven Energielieferverträge"}</b>
                {filteredElvs && filteredElvs.length > 0 &&
                    filteredElvs.map((e, i) => (
                        <div key={i}>
                            {i < showLimit && <DashElv key={e.id} elv={e} />}
                            {i > showLimit - 1 && toggleAll === true && <DashElv key={e.id} elv={e} />}
                        </div>
                    ))
                }
                {filteredElvs.length > showLimit &&
                    <div className="text-center" key="no-elv">
                        <a onClick={e => {e.preventDefault(); setToggleAll(!toggleAll)}} href="/alle" className="link-energo">{toggleAll ? "weniger anzeigen" : "Alle Energielieferverträge anzeigen"}</a>
                    </div>
                }
            </CardBody>
        </Card>
    )
}
export default DashElvsCard;